import React, {useState, useContext, useEffect} from 'react';
import { Card, NavDropdown  } from 'react-bootstrap';
import Slider from '@mui/material/Slider';
import { useWidgetContext } from '../context/DragContext';
import { AuthContext } from '../context/AuthContext';

function SymbolDetailsAnalyze() {

  const [showDropdown, setShowDropdown] = useState(false);
  const { removeWidgetFromGrid } = useWidgetContext();
  const { addWatchlist, watchlistData, deleteWatchlist, getWatchLists, priceChange, currentPrice, selectedValueAnalysis, olChange, highPrice, lowPrice  } = useContext(AuthContext);
  const [isOnWatchlist, setIsOnWatchlist] = useState(false);
  const [id, setId] = useState([]);
  const [name, setName] = useState("");
  const [rows, setRows] = useState([]);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
      if (selectedValueAnalysis[0]) {
        setId(selectedValueAnalysis[0]["conid"]);
        setName(selectedValueAnalysis[0]["55"]);
        setRows([{ C: selectedValueAnalysis[0]["conid"] }]);
      }
    }, [selectedValueAnalysis]);

  const averagePrice = priceChange?.["5d"]
  ? ((priceChange?.["5d"].end_price + priceChange?.["5d"].start_price) / 2).toFixed(2)
  : null;

  const handleToggle = (isOpen) => {
      setShowDropdown(isOpen);
  };

  const handleSvgClick = () => {
      setShowDropdown(!showDropdown);
  };

  useEffect(() => {
      if (Array.isArray(watchlistData)) {
          const isItemInWatchlist = watchlistData.some((list) => list.id === id.toString());
          setIsOnWatchlist(isItemInWatchlist);
      } else {
          setIsOnWatchlist(false);
      }
    }, [watchlistData, id]);
  

  const handleAddClick = async () => {
    try {
      const response = await addWatchlist(id, name, rows); 
      
      if(response.message === "Watchlist added successfully"){
        await getWatchLists(); 
        setIsOnWatchlist(true);
        // console.log('Add Watchlist Response:', response);
      }
      else{
        console.log('failed to add to  watchlist');
      }
    } catch (error) {
      console.error('Error adding to watchlist:', error);
    }
  };

  const handleDeleteClick = async () => {
    try {
      const response = await deleteWatchlist(id); 
      if(response.message === "Watchlist deleted successfully"){
        await getWatchLists(); 
        setIsOnWatchlist(false);
        // console.log('Delete Watchlist Response:', response);
      }
      else{
        console.log('failed to add to  watchlist');
      }
    } catch (error) {
      console.error('Error adding to watchlist:', error);
    }
  };

  const toggleMoreInfo = () => {
    setShowMore(!showMore);
  };

  return (
    <Card className="main-card mt-3">
      <Card.Header className="pb-0">
        <div className="d-flex justify-content-between mt-1">
          <h2 className="medium-heading mb-0">{ selectedValueAnalysis[0]?.["55"] }</h2>
            <div>
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  onClick={handleSvgClick}
                  style={{ cursor: 'pointer' }}
                  >
                  <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
                  <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
                  <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
              </svg>
              <NavDropdown
                  show={showDropdown}
                  onToggle={handleToggle}
                  title=""
                  id="nav-dropdown"
                  align="end"
                  className="d-inline custom-nav-dropdown"
                  style={{ display: showDropdown ? 'block' : 'none' }}
                  >
                  <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('info')}>Close Window</NavDropdown.Item>
              </NavDropdown>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="pt-0 scrollbar-custom">
        <div className="d-flex justify-content-between align-items-center mt-1">
          <div className="d-flex text-success align-items-center">
            <h1 className="large-h1 mb-0">{currentPrice?.toFixed(2) || "0"}</h1>
            <div>
            <p className={`pl-2 mb-0 symbol-details-text ${selectedValueAnalysis[0]?.["82"] && selectedValueAnalysis[0]?.["83"] > 0 ? 'text-success' : 'text-danger'}`}> 
            {selectedValueAnalysis[0]?.["82"] === "0" ? "0" : selectedValueAnalysis[0]?.["82"] ? parseFloat(selectedValueAnalysis[0]["82"]).toFixed(2) : "0"}
            </p>
              <p className={`pl-2 mb-0 symbol-details-text ${selectedValueAnalysis[0]?.["82"] && selectedValueAnalysis[0]?.["83"] > 0 ? 'text-success' : 'text-danger'}`}> 
               {selectedValueAnalysis[0]?.["83"] === "0" ? "0" : selectedValueAnalysis[0]?.["83"] ? parseFloat(selectedValueAnalysis[0]["83"]).toFixed(2) : "0"}%
            </p>
            </div>
          </div>
          <div>
            {isOnWatchlist ? (
              <img src={`${process.env.PUBLIC_URL}/images/filled_bookmark.svg`} height="23" width="20" onClick={handleDeleteClick}alt="bookmark-icon" />
            ) : (
              <img src={`${process.env.PUBLIC_URL}/images/bookmark.svg`} onClick={handleAddClick} height="28" width="24" alt="bookmark-icon" />
            )}
          </div>
        </div>

        <div className="row mt-2 pl-2 pr-2">
          <div className="col-6 text-danger bold">{selectedValueAnalysis[0]?.["71"] === "0" ? "0" : selectedValueAnalysis[0]?.["71"] ? parseFloat(selectedValueAnalysis[0]["71"]).toFixed(2) : "N/A"}</div>
          <div className="col-6 text-success text-end bold">{selectedValueAnalysis[0]?.["70"] === "0" ? "0" : selectedValueAnalysis[0]?.["70"] ? parseFloat(selectedValueAnalysis[0]["70"]).toFixed(2) : "N/A"}</div>
          <div className="col-2 low-high">Low</div>
          <div className="col-8 ps-0 pe-0">
          <Slider
            aria-label="Custom marks"
            value={isNaN(currentPrice) ? 0 : currentPrice} 
            min={isNaN(selectedValueAnalysis[0]?.["71"]) ? 0 : parseFloat(selectedValueAnalysis[0]?.["71"])}
            max={isNaN(selectedValueAnalysis[0]?.["70"]) ? 1000 : parseFloat(selectedValueAnalysis[0]?.["70"])}
            step={0.01}
            getAriaValueText={(value) => isNaN(value) ? '0' : `${value}`}
            valueLabelDisplay="on"
            disabled 
          />
          </div>
          <div className="col-2 low-high text-end">High</div>
        </div>

        <div className="row pl-2 pr-1">
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Prev. Close</span> <br />
            <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["7741"] === "0" ? "0" : selectedValueAnalysis[0]?.["7741"] ? parseFloat(selectedValueAnalysis[0]["7741"]).toFixed(2) : "N/A"}</span>
          </div>
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Ol</span> <br />
            <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["7697"] === "0" ? "0" : selectedValueAnalysis[0]?.["7697"] ? parseFloat(selectedValueAnalysis[0]["7697"]).toFixed(2) : "N/A"}</span>
          </div>
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Ol Chg</span> <br />
            <span className="bold symbol-details-prev">{olChange?.toFixed(2) ||  "N/A"}</span>
          </div>
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Lot Size</span> <br />
            <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["7059"] === "0" ? "0" : selectedValueAnalysis[0]?.["7059"] ? parseFloat(selectedValueAnalysis[0]["7059"]).toFixed(2) : "N/A"}</span>
          </div>
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Volume</span> <br />
            <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["87"] || "N/A"}</span>
          </div>
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Bid</span> <br />
            <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["84"] === "0" ? "0" : selectedValueAnalysis[0]?.["84"] ? parseFloat(selectedValueAnalysis[0]["84"]).toFixed(2) : "N/A"}</span>
          </div>
          <div className="col-3 mt-2">
            <span className="gray-text f-s-14">Ask</span> <br />
            <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["86"] === "0" ? "0" : selectedValueAnalysis[0]?.["86"] ? parseFloat(selectedValueAnalysis[0]["86"]).toFixed(2) : "N/A"}</span>
          </div>
          {!showMore ? (
            <div className="col-3 mt-3" style={{cursor:'pointer'}} onClick={toggleMoreInfo}>
              <span className="symbol-details-prev">More</span>
              <img src={`${process.env.PUBLIC_URL}/images/down 2.svg`} alt="icon" style={{marginLeft:'4px', marginTop: '-3px'}}/>
            </div>
          ) : (
            <>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">Open Interest</span> <br />
                <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["7085"] === "0" ? "0" : selectedValueAnalysis[0]?.["7085"] ? parseFloat(selectedValueAnalysis[0]["7085"]).toFixed(2) : "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">5 Day</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["5d"].percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["5d"].percent_change === "0" ? "0" : priceChange?.["5d"].percent_change ? parseFloat(priceChange?.["5d"].percent_change).toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">1 Month</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["1m"].percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["1m"].percent_change === "0" ? "0" : priceChange?.["1m"].percent_change ? parseFloat(priceChange?.["1m"].percent_change).toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">3 Month</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["3m"].percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["3m"].percent_change === "0" ? "0" : priceChange?.["3m"].percent_change ? parseFloat(priceChange?.["3m"].percent_change).toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">1 Year</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["1y"].percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["1y"].percent_change === "0" ? "0" : priceChange?.["1y"].percent_change ? parseFloat(priceChange?.["1y"].percent_change).toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">SPX Delta</span> <br />
                <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["7696"] === "0" ? "0" : selectedValueAnalysis[0]?.["7696"] ? parseFloat(selectedValueAnalysis[0]["7696"]).toFixed(2) : "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">Beta</span> <br />
                <span className="bold symbol-details-prev">{selectedValueAnalysis[0]?.["7718"] === "0" ? "0" : selectedValueAnalysis[0]?.["7718"] ? parseFloat(selectedValueAnalysis[0]["7718"]).toFixed(2) : "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">5-Day Chg</span> <br />
                <span className="bold symbol-details-prev">{averagePrice || "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">52-Week Range</span> <br />
                <span className="bold symbol-details-prev">
                  {selectedValueAnalysis[0]?.["7293"] || selectedValueAnalysis[0]?.["7294"]
                    ? `${selectedValueAnalysis[0]?.["7293"] === "0" ? "0" : selectedValueAnalysis[0]?.["7293"] ? parseFloat(selectedValueAnalysis[0]["7293"]).toFixed(2) : "-"} - ${
                        selectedValueAnalysis[0]?.["7294"] === "0" ? "0" : selectedValueAnalysis[0]?.["7294"] ? parseFloat(selectedValueAnalysis[0]["7294"]).toFixed(2) : "-"
                      }`
                    : "N/A"}
                </span>
              </div>
            </>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default SymbolDetailsAnalyze;
